var _classCallCheck = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _defineProperty = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/defineProperty", "@babel/runtime/helpers/objectSpread", "react", "./objectGet"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/defineProperty"), require("@babel/runtime/helpers/objectSpread"), require("react"), require("./objectGet"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a._extends, a.defineProperty, a.objectSpread, a.react, a.objectGet), a.connect = c.exports;
  }
})(this, function (a, b, c, d, e, f) {
  "use strict";

  var h = require("@babel/runtime/helpers/interopRequireDefault");

  function g(a, b, c) {
    return "function" == typeof a ? a(b, c) : Array.isArray(a) ? a.reduce(function (a, c) {
      return (0, d.default)({}, a, _defineProperty({}, c, b[c]));
    }, {}) : "object" == typeof a ? Object.keys(a).reduce(function (c, e) {
      return (0, d.default)({}, c, "*" === e ? (0, f.default)(b, a[e]) : _defineProperty({}, e, (0, f.default)(b, a[e])));
    }, {}) : {};
  }

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.connect = void 0, b = h(b), c = h(c), d = h(d), e = h(e), f = h(f);

  var i = function i(_ref3) {
    var a = _ref3.Consumer;
    return function () {
      for (var _len = arguments.length, d = new Array(_len), _key = 0; _key < _len; _key++) {
        d[_key] = arguments[_key];
      }

      return function (f) {
        function h(b, c) {
          return e.default.createElement(a, null, function (a) {
            return e.default.createElement(j, {
              context: a,
              props: b,
              forwardedRef: c
            });
          });
        }

        var i = 1 < d.length || "string" == typeof d[0] ? d : d[0];

        var j =
        /*#__PURE__*/
        function (_e$default$Component) {
          _inherits(j, _e$default$Component);

          function j(a) {
            var _this;

            _classCallCheck(this, j);

            _this = _possibleConstructorReturn(this, _getPrototypeOf(j).call(this, a)), _this.state = {}, _this.state = _this.getNewState(a.context, a.props);
            return _this;
          }

          _createClass(j, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref4) {
              var a = _ref4.context,
                  b = _ref4.props;
              var c = this.props.props;
              return b !== c || !!this.getNewState(a, c);
            }
          }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate(_ref5) {
              var a = _ref5.context;
              var b = this.props.context;
              b !== a && this.updateFromContext();
            }
          }, {
            key: "getNewState",
            value: function getNewState(a, b) {
              var c = this.state,
                  d = g(i, a, b),
                  e = Object.keys(d).reduce(function (a, b) {
                return a || d[b] !== c[b];
              }, !1);
              return !!e && d;
            }
          }, {
            key: "updateFromContext",
            value: function updateFromContext() {
              var _this$props = this.props,
                  a = _this$props.context,
                  b = _this$props.props,
                  c = this.getNewState(a, b);
              c && this.setState(c);
            }
          }, {
            key: "render",
            value: function render() {
              var a = this.state,
                  _this$props2 = this.props,
                  c = _this$props2.props,
                  d = _this$props2.forwardedRef;
              return e.default.createElement(f, (0, b.default)({}, a, c, {
                ref: d
              }));
            }
          }]);

          return j;
        }(e.default.Component);

        (0, c.default)(j, "defaultProps", {
          context: {}
        });
        var k = f.displayName || f.name;
        return h.displayName = "connect()(".concat(k, ")"), e.default.forwardRef(h);
      };
    };
  };

  a.connect = i;
  a.default = i;
});